import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderLawEnforcement from "../../../../src/content/law-enforcement-prayer-resource/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderLawEnforcement,
  React
};